export const inputClasses =
  'w-full appearance-none grow h-10 py-2 px-3 rounded border text-sm focus:outline-none focus:shadow-outline border-gray-200 dark:border-gray-600 text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-700';
export const textareaClasses = `${inputClasses} !h-auto pt-1`;
export const inputWarningClass = 'border-red-300';
